import { useRef } from "react";

import { useFormikContext } from "formik";
import { Input, ActionBlock } from "neetoui/formik";
import { useTranslation } from "react-i18next";

import SendToFields from "components/SendToFields";

import AdvancedProperties from "./AdvancedProperties";
import EmailBody from "./EmailBodyEditor";

const Form = ({
  showSendFromField,
  disableReplyTo,
  showVideoEmbedInEditor,
  children,
}) => {
  const { initialValues } = useFormikContext();
  const editorRef = useRef();
  const { t } = useTranslation();

  const handleReset = () =>
    editorRef.current.editor.commands.setContent(initialValues.emailBody);

  return (
    <>
      <div className="flex flex-col gap-y-6">
        <SendToFields
          showUploadCsvButton
          emailInputProps={{
            label: t("neetoMolecules.shareViaEmail.sendTo"),
            name: "notifyEmails",
            required: true,
          }}
        />
        <Input
          required
          className="col-span-1"
          label={t("neetoMolecules.shareViaEmail.subject")}
          name="emailSubject"
        />
        <EmailBody
          {...{ showVideoEmbedInEditor }}
          id="emailBody"
          ref={editorRef}
        />
        <div ref={editorRef} />
        <AdvancedProperties {...{ disableReplyTo, showSendFromField }} />
      </div>
      {children && (
        <div className="neeto-ui-border-gray-300 mt-4 border-t py-4">
          <h3 className="mb-4">
            {t("neetoMolecules.shareViaEmail.additionalOptions")}
          </h3>
          {children}
        </div>
      )}
      <div className="neeto-ui-bg-white sticky bottom-0 z-10 mt-6 py-6">
        <ActionBlock
          cancelButtonProps={{
            label: t("neetoMolecules.shareViaEmail.reset"),
            type: "reset",
            onClick: handleReset,
          }}
          submitButtonProps={{
            label: t("neetoMolecules.shareViaEmail.sendEmail"),
          }}
        />
      </div>
    </>
  );
};

export default Form;
